import { constantRouterMap, routerMap, wildcard } from '@/router'
// import { getRoutes } from '@/api/login'
import { getUserMenu } from '@/api/system/menuManager'
import { getUserLanguage } from '@/utils/auth'
import store from '@/store'

const lang = getUserLanguage()

function filterAsyncRoute(routeNames, routes, parentLevel) {
  const asyncRoutes = []
  if (routeNames && routeNames.constructor === Array) {
    routeNames.forEach(r => {
      r.level = parentLevel + 1
      let sourceRoute = null
      if (typeof routes === 'object' && routes.constructor === Array) {
        sourceRoute = routes.filter(sr => {
          if (sr.name === r.url && r.functionType === 1 && r.isShow === 1) {
            sr.menuName = lang === 'zh' ? r.functionName : r.functionNameEn
            sr.level = r.level
            // 处理页面按钮
            if (r.children && r.children.length > 0 && r.children[0].functionType === 2) {
              sr.button = r.children
            }
            return sr
          }
          if (r.url == 'map' || r.url.indexOf('map#') === 0) {
            store.dispatch('setFullScreenMap', {
              visible: true,
              params: r.url.split('#')[1]
            })
          }
        })[0]
      }
      if (sourceRoute) {
        const targetRoute = Object.assign({}, sourceRoute)

        if (r.children) {
          targetRoute.children = filterAsyncRoute(r.children, sourceRoute.children, r.level)
        }
        asyncRoutes.push(targetRoute)
      }
    })
  }
  return asyncRoutes
}
const permission = {
  state: {
    keys: 'permission',
    routers: constantRouterMap,
    addRouters: [],
    realRouters: constantRouterMap || [],
    addRealRouters: [],
    fullscreenMap: false,
    mapParams: ''
  },
  mutations: {
    setRoutes: (state, routes) => {
      state.addRouters = routes
      state.routers = constantRouterMap.concat(routes)
    },
    setRealRoutes: (state, routes) => {
      state.addRealRouters = routes
      state.realRouters = constantRouterMap.concat(routes)
    },
    setFullScreenMap: (state, { visible, params }) => {
      state.fullscreenMap = visible
      state.mapParams = params
    }
  },
  actions: {
    generateRoutes({ commit }) {
      return new Promise(resolve => {
        getUserMenu().then(res => {
          commit('setRoutes', filterAsyncRoute(res.data.data, routerMap, 0).concat(wildcard))
          resolve()
        }).catch( ()=> {
          // console.log('1111')
        })
      })
    },
    generateRealRoutes({ commit }, data) {
      commit('setRealRoutes', data.concat(wildcard))
    },
    setFullScreenMap({ commit }, data) {
      commit('setFullScreenMap', data)
    }
  }
}
export default permission
